import React, { useEffect } from 'react';
import NetInfo from '@react-native-community/netinfo';
import { triggerQueueProcessing } from './OfflineQueue';

/**
 * NetworkMonitor component that listens for network changes
 * and triggers queue processing when the device comes back online
 */
export const NetworkMonitor = () => {
  useEffect(() => {
    // Function to handle network state changes
    const handleNetworkChange = (state) => {
      console.log('Network state changed:', state);
      
      // If the device is now connected to the internet
      if (state.isConnected && state.isInternetReachable) {
        console.log('Device is back online. Triggering queue processing...');
        
        // Process any pending items in the offline queue
        triggerQueueProcessing()
          .then(result => {
            console.log('Queue processing result:', result);
          })
          .catch(error => {
            console.error('Failed to process queue:', error);
          });
      }
    };
    
    // Subscribe to network state changes
    const unsubscribe = NetInfo.addEventListener(handleNetworkChange);
    
    // Initial check of network state
    NetInfo.fetch().then(state => {
      console.log('Current network state:', state);
      
      // If already connected, check for pending items
      if (state.isConnected && state.isInternetReachable) {
        console.log('Device is online. Checking for pending items...');
        
        triggerQueueProcessing()
          .then(result => {
            console.log('Initial queue processing result:', result);
          })
          .catch(error => {
            console.error('Failed to process queue initially:', error);
          });
      }
    });
    
    // Cleanup function to unsubscribe when component unmounts
    return () => {
      unsubscribe();
    };
  }, []);
  
  // This component doesn't render anything
  return null;
};

export default NetworkMonitor;